import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { get } from 'lodash';

import { BaseModalComponent } from 'common/src/modules/rnpl-common/components';
import { ToasterService } from 'common/src/modules/ui-components/toaster';
import { AccountingReportsSettingsService } from 'projects/workspace/src/app/accounting/accounting-settings-module/services';
import { AccountingReportsModel } from 'projects/workspace/src/app/accounting/accounting-settings-module/models';

@Component({
  selector: 'rnpl-add-tax-code-modal',
  templateUrl: './add-tax-code-modal.component.html',
  styleUrls: ['./add-tax-code-modal.component.scss'],
})
export class AddTaxCodeModalComponent extends BaseModalComponent implements OnDestroy {

  public form: FormGroup;

  readonly submitRequest$: BehaviorSubject<boolean> = new BehaviorSubject(null);

  constructor(
    public toasterService: ToasterService,
    private fb: FormBuilder,
    private accountingReportsSettingsService: AccountingReportsSettingsService,
    public dialogRef: MatDialogRef<AddTaxCodeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      settings: AccountingReportsModel
    }
  ) {
    super(toasterService);

    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });

    this.initForm();
  }

  private initForm(): void {
    this.form = this.fb.group({
      vatNumber: this.fb.group({
        left: [get(this.data, 'settings.vatNumber.left'), {validators: Validators.required}],
        middle: [get(this.data, 'settings.vatNumber.middle'), {validators: Validators.required}],
        right: [get(this.data, 'settings.vatNumber.right')],
      }),
      noVatNumber: [get(this.data, 'settings.noVatNumber')],
    });
  }

  public submit(): void {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();

    if (this.form.invalid) { return; }
    if (this.submitRequest$.getValue()) { return; }

    this.submitRequest$.next(true);

    const settings = {
      ...this.data.settings,
      ...this.form.getRawValue()
    };
    this.accountingReportsSettingsService.updateReportsSettings(settings)
      .pipe(
        takeUntil(this._destroy)
      )
      .subscribe(() => {
        this.toasterService.notify({message: 'COMMON.CHANGES_SAVED', type: 'success'});
        this.dialogRef.close(true);
      });
  }

  public noVatChanged(clearValue = false): void {
    if (this.noVatNumberControl.value) {
      this.form.get('vatNumber').disable();
      if (clearValue) {
        this.form.get('vatNumber').reset();
      }
    } else {
      this.form.get('vatNumber').enable();
    }
  }

  get vatNumberLeftControl(): FormControl { return this.form.get('vatNumber').get('left') as FormControl; }
  get vatNumberMiddleControl(): FormControl { return this.form.get('vatNumber').get('middle') as FormControl; }
  get vatNumberRightControl(): FormControl { return this.form.get('vatNumber').get('right') as FormControl; }
  get noVatNumberControl(): FormControl { return this.form.get('noVatNumber') as FormControl; }

}
